import React from 'react';
import { FormWrapperDesktop } from '@alfa-bank/site-form-wrapper/desktop';

import { Form } from '../../../form';
import type { IForm } from '../../../models';

/** Адаптер рамки формы, чтобы убрать рамку из Form */
export const FormWrapperAdapter = ({
    className,
    hideWrapper,
    isShadowEnabled = true,
    ...proxyProps
}: IForm) => {
    if (!hideWrapper) {
        return (
            <FormWrapperDesktop className={className} shadow={isShadowEnabled}>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <Form {...proxyProps} />
            </FormWrapperDesktop>
        );
    }

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Form className={className} {...proxyProps} />;
};
